// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2TJ98","footer__language-options":"Footer_footer__language-options__gaD1U"};